import React from 'react'
import PropTypes from 'prop-types'
import MEModal from '../../components/MEModal'
import { Button } from 'react-bootstrap'

const DeleteModal = props => {
  return (
    <MEModal
      show={props.modalOpen}
      close={props.openCloseModal}
      title="Delete Assignment"
    >
      <p className="text-center">Delete assessment: {props.title}</p>
      <div className="text-center mb-4">
        <Button
          type="button"
          bsStyle="danger"
          className="btn-myed btn-danger-myed mr-5"
          onClick={props.deleteAct}
        >
          Delete
        </Button>
        <Button
          type="button"
          bsStyle="default"
          className="btn-myed btn-default-myed"
          onClick={props.openCloseModal}
        >
          Cancel
        </Button>
      </div>
    </MEModal>
  )
}

export default DeleteModal

DeleteModal.propTypes = {
  title: PropTypes.string,
  actPk: PropTypes.string,
  canvasId: PropTypes.number,
  modalOpen: PropTypes.bool,
  openCloseModal: PropTypes.func,
  deleteAct: PropTypes.func,
}
